/**
 * Created by DSadler on 18/04/2017.
 */
import React, {Component} from 'react';

let dropZoneStyle = {
  //backgroundColor: "#ffffff",
  borderWidth : "5px",
  borderStyle: "double",
  borderColor: "#c0c0c0",
  color : "#c0c0c0",
  fontSize : "40px",
  height : "130px",
  lineHeight: "130px",
  textAlign: "center",
  verticalAlign: "middle",
  width: "calc(100% - 10px)",
};

class DropZone extends Component {
  constructor(props){
    super(props);
    this.state = {
      style: dropZoneStyle
    };
  }
  
  render() {
    return (
      <div
        className="placeholder"
        style={this.state.style}
      >
        {this.props.text}
      </div>);
  }
}

export default DropZone;


// WEBPACK FOOTER //
// ./src/App/Editor/components/ui/DropZone.js